const BASE_PATH = '/api/reports/';

const getReportUrl = reportName => `${BASE_PATH}${reportName}`;

export default getReportUrl;
